module.exports = __webpack_public_path__ + "img/diapositiva-2-2.d8bca692.png";